import React from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';
import { Wallet } from 'lucide-react';

const fmtAED = (n) => `AED ${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmtDays = (n) => `${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })} day${Number(n) === 1 ? '' : 's'}`;

const AdvanceRecoveryDialog = ({ open, onOpenChange, info, onConfirm }) => {
  if (!info) return null;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="advance-recovery-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Wallet className="h-5 w-5 text-amber-600" /> Advance Leave Salary to Recover
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-left">
              <p>
                <b>{info.employee_name}</b> ({info.employee_code}) is leaving on{' '}
                <b>{info.last_working_date}</b> — before the end of {info.exit_year}. They were paid
                annual leave in advance beyond what they had earned by their last working day.
              </p>
              <div className="rounded-lg border bg-amber-50/60 p-3 space-y-1.5">
                <div className="flex justify-between"><span className="text-muted-foreground">Carry-forward into {info.exit_year}</span><span className="font-medium">{fmtDays(info.carry_forward_into_year)}</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Accrued to last working day ({info.accrual_rate}/mo)</span><span className="font-medium">{fmtDays(info.accrued_to_last_working_date)}</span></div>
                <div className="flex justify-between border-b pb-1.5"><span className="text-muted-foreground">Eligible (paid) days</span><span className="font-medium">{fmtDays(info.eligible_days)}</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Annual days taken & paid in {info.exit_year}</span><span className="font-medium">{fmtDays(info.taken_paid_this_year)}</span></div>
                <div className="flex justify-between text-rose-700 font-semibold pt-1"><span>Advance days to recover</span><span data-testid="recovery-days">{fmtDays(info.recovery_days)}</span></div>
                <div className="flex justify-between text-rose-700 font-semibold"><span>Amount to recover (@ {fmtAED(info.daily_rate)}/day)</span><span data-testid="recovery-amount">{fmtAED(info.recovery_amount)}</span></div>
              </div>
              <p className="text-xs text-muted-foreground">
                Recover this from the final salary or EOSB settlement. Saving will not deduct it
                automatically — this is a reminder for you to action manually.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="recovery-cancel-btn">Go back</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="recovery-confirm-btn" className="bg-amber-600 hover:bg-amber-700">
            Acknowledge & Save
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AdvanceRecoveryDialog;
